import { jsx, jsxs } from 'react/jsx-runtime';
import { IconCheck } from '@belong/icons';
import { useListboxContext, ListboxOption } from '@reach/listbox';

const DropdownMenuItem = ({
  children,
  value
}) => {
  const {
    value: selectedValue
  } = useListboxContext();
  return jsx(ListboxOption, {
    className: "h-[1px] min-h-[106px] cursor-pointer p-sm",
    value: value,
    children: jsxs("div", {
      className: "flex h-full w-full items-center justify-between",
      children: [jsx("div", {
        className: "flex h-full w-full",
        children: children
      }), jsx("div", {
        className: "h-full w-xl",
        children: value === selectedValue && jsx("div", {
          className: "flex h-full items-center justify-end",
          children: jsx(IconCheck, {
            height: 16,
            className: "text-green"
          })
        })
      })]
    })
  });
};
DropdownMenuItem.displayName = 'DropdownMenu.Item';

export { DropdownMenuItem };
